import { SVGProps } from "react";
const PostSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.362 4.487 19.049 2.8a1.875 1.875 0 0 1 2.652 2.652l-10.619 10.62a4.499 4.499 0 0 1-1.897 1.13L6.5 18l.8-2.686a4.5 4.5 0 0 1 1.13-1.897l8.932-8.93Zm0 0L20 7.125M18.5 14v4.75A2.25 2.25 0 0 1 16.25 21H5.75a2.25 2.25 0 0 1-2.25-2.25V8.25A2.25 2.25 0 0 1 5.75 6h4.75"
    />
  </svg>
);
export default PostSvg;
